import { useTranslation } from "react-i18next";
import submit from "submit-form";
import PlanCard from "./PlanCard";
import PlanDetails from "./PlanDetails";
import PaymentDetails from "./PaymentDetails";
import SvgIcon from "../../../../parts/SvgIcon";
import Select from "../../../../parts/inputs/select";
import { truncateText } from "../../../../utils/string-helpers";

const ChangePlan = ({
  toggleDrawer,
  planData,
  sub,
  selectedPlan,
  setSelectedPlan,
  price,
  upcomingInvoice,
  setInitState,
}) => {
  const { t } = useTranslation("coaching-portal");
  const newPlan = !!price && !!upcomingInvoice;
  const changePlanTextButton =
    selectedPlan?.nickname && selectedPlan.nickname.length < 15
      ? t("membershipList.changeToPlan", { nickname: selectedPlan.nickname })
      : t("membershipList.changePlanButton");

  const selectOptions =
    planData && planData.selectPlans && Array.isArray(planData.selectPlans)
      ? [
          { value: "", label: t("membershipList.selectNewPlan") },
          ...planData.selectPlans.map((plan) => ({
            value: plan.value,
            label: truncateText(plan.label, 32),
          })),
        ]
      : [];

  return (
    <>
      <header className="details-header">
        <h4>{t("membershipList.changePlanTitle")}</h4>

        <a
          href="#_"
          onClick={toggleDrawer}
          role="button"
          data-button-type="tertiary"
          data-icon-only="true"
        >
          <img src="/img/new-icons/red-cross.svg" alt={t("membershipList.dismiss")} />
        </a>
      </header>

      {planData && (
        <PlanCard
          data={planData}
          sub={sub}
          selectedPlan={selectedPlan}
          activePlan={!newPlan}
        />
      )}
      <fieldset>
        <legend>
          {newPlan
            ? t("membershipList.paymentDetails")
            : t("membershipList.changePlanButton")}
        </legend>
      </fieldset>

      {planData?.selectPlans && !newPlan && (
        <Select
          instanceId="price"
          autosize={true}
          matchPos="start"
          clearable={false}
          options={selectOptions}
          simpleValue
          onChange={(value) => {
            const plan = planData.selectPlans.find(({ id }) => id === value);
            setSelectedPlan(plan);
          }}
          value={selectedPlan?.value || ""}
        />
      )}

      {selectedPlan && !newPlan && <PlanDetails selectedPlan={selectedPlan} />}

      {selectedPlan && newPlan && (
        <PaymentDetails
          invoice={upcomingInvoice}
          currency={planData.currency}
        />
      )}

      {selectedPlan && (
        <a
          href="#_"
          role="button"
          data-button-type="primary"
          onClick={(e) => {
            e.preventDefault();
            if (newPlan) {
              setInitState();
              submit("/actions/user/change-membership", {
                method: "POST",
                body: {
                  price: selectedPlan.id,
                  customer: sub.customer,
                },
              });
            } else {
              submit("/actions/refresh", {
                method: "GET",
                body: {
                  price: selectedPlan.id,
                },
              });
            }
          }}
        >
          {newPlan ? t("membershipList.confirm") : changePlanTextButton}
        </a>
      )}
    </>
  );
};

export default ChangePlan;
